export const reportScopes = {
  ACCOUNT: 'account',
  GLOBAL: 'global',
  CLASS: 'class',
}
